import { render } from "./DonutsDashboard.vue?vue&type=template&id=ccc05c58"
import script from "./DonutsDashboard.vue?vue&type=script&lang=js"
export * from "./DonutsDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__